<!-- =========================================================================================
  File Name: MailBox.vue
  Description: MailReceive page
  Ref: mail_frontend/src/views/admin/user/User.vue
  
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: hopdt
  Created at: 25/08/2021 
========================================================================================== -->

<template>
  <div id="page-user-list" class="vx-card p-6 page-mail-box-full">

    <!--      Search area-->
    <vx-card ref="filterCard" @keyup.enter="pressEnterSearch" id="user_list_filters" tabindex="0" title="" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters()" @remove="resetColFilters()">

      <div class="vx-row">
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">方法</label>
          <v-select class="w-full"
                    id="inquiry_type_search"
                    v-model="inquiry_type_search"
                    :options="listInquiryTypeSelect"
                    @input="clearFocusTypeDropdown()">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ日（から）</label>
          <flat-pickr id="receive_date_search_from"
                      class="w-full flatpickr-style"
                      v-model="receive_date_search_from"
                      placeholder="..."
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ日（まで）</label>
          <flat-pickr id="receive_date_search_to"
                      class="w-full flatpickr-style"
                      v-model="receive_date_search_to"
                      placeholder="..."
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">回答期日</label>
          <flat-pickr id="response_date_search"
                      class="w-full flatpickr-style"
                      placeholder="..."
                      v-model="response_date_search"
                      :config="configDate"
                      @on-change="clearFocusTypeDropdown()">
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">担当者</label>
          <v-select :class="checkIsMultiple.mst_user ? 'w-full show-feature-x' : 'w-full'"
                    id="mst_user_search"
                    v-model="mst_user_search"
                    placeholder="..."
                    :multiple="checkIsMultiple.mst_user"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listMstUserSelect => listMstUserSelect.value"
                    :options="listMstUserSelect">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">状態</label>
          <v-select :class="checkIsMultiple.state_flg ? 'w-full show-feature-x' : 'w-full'"
                    id="state_flg_search"
                    v-model="state_flg_search"
                    placeholder="..."
                    :multiple="checkIsMultiple.state_flg"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listSelectStateFlag => listSelectStateFlag.value"
                    :options="listSelectStateFlag">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">種別</label>
          <v-select :class="checkIsMultiple.type ? 'w-full show-feature-x' : 'w-full'"
                    id="type_search"
                    v-model="type_search"
                    placeholder="..."
                    :multiple="checkIsMultiple.type"
                    :close-on-select="false"
                    @input="selectionChangedvSelect(); clearFocusTypeDropdown();"
                    @open="openvSelect"
                    :deselectFromDropdown="true"
                    :reduce="listTypeSelect => listTypeSelect.value"
                    :options="listTypeSelect">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせID</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    type="number"
                    min="0"
                    @focus="lockSigned"
                    @blur="unlockSigned"
                    v-model.number="inquiry_id_search"
                    icon-after="true" :icon="inquiry_id_search ? iconVsInput : ''"
          />
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ者</label>
          <vs-input class=" mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="receive_mail__email_sender_search"
                    v-model="receive_mail__email_sender_search"
                    icon-after="true" :icon="receive_mail__email_sender_search ? iconVsInput : ''"
                    :maxlength="512">
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">タイトル</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="subject_search"
                    v-model="subject_search" icon-after="true" :icon="subject_search ? iconVsInput : ''" >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">本文</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="body_search"
                    v-model="body_search" icon-after="true" :icon="body_search ? iconVsInput : ''" >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">メール返信</label>
          <v-select class="w-full"
                    id="email_reply_search"
                    v-model="email_sender_search"
                    :options="listSentUserNameSelect"
                    @input="clearFocusTypeDropdown()">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">TO メール</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="to_search__email_sender_search"
                    v-model="to_search__email_sender_search"
                    icon-after="true" :icon="to_search__email_sender_search ? iconVsInput : ''" >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">CC メール</label>
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    id="cc_search__email_sender_search"
                    v-model="cc_search__email_sender_search"
                    icon-after="true" :icon="cc_search__email_sender_search ? iconVsInput : ''" >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">顧客</label>
          <v-select class="w-full"
                    v-model="customer_domain_search"
                    placeholder="..."
                    :options="listCustomerSelect"
                    @input="clearFocusTypeDropdown()">
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <vs-checkbox v-model="searchSubFolder" class="w-full mt-8" :style="isSpamView ? 'display:none' : ''">サブフォルダを含む</vs-checkbox>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">優先度</label>
          <v-select class="w-full"
                    id="priority_search"
                    v-model="priority_search"
                    placeholder="..."
                    :options="listPriority"
                    @open="openvSelectPriority"
                    @input="selectionChangedPriority(); clearFocusTypeDropdown();"
                    >
            <span slot="no-options" class="text-xs">すみません、マッチングオプションがありません。</span>
          </v-select>
        </div>
        <img id="gif-low-priority" style="display:none" src="@/assets/images/other-icons/low-priority.gif"/>
        <img id="gif-medium-priority" style="display:none" src="@/assets/images/other-icons/medium-priority.gif"/>
        <img id="gif-high-priority" style="display:none" src="@/assets/images/other-icons/high-priority.gif"/>
        
        <div class="vx-col flex flex-wrap justify-end m-auto mb-0 pt-2 lg:w-full sm:w-1/2 w-full">
          <vs-button icon="assignment" :disabled="readOnly" @click="onSendReport" color="success">新規作成</vs-button>
          <vs-button icon="search" @click="onSearch(true)" color="primary" class="ml-2">検索 </vs-button>
        </div>
      </div>
    </vx-card>

    <!-- dialog confirm -->
    <vs-popup ref="dialogConfirm" title="選択したメールのバッチ更新" :active.sync="activeConfirm" button-close-hidden>
        <div style="position:relative; padding: 50px 50px 0px 50px">
            <div>
              <label class="text-sm opacity-75">担当者</label>
              <v-select class="w-full"
                        id="update_mst_user"
                        v-model="update_mst_user"
                        placeholder="..."
                        :options="listMstUserSelectRemoveNotSet">>
              </v-select>
            </div>
            <div style="margin-top:20px">
              <label class="text-sm opacity-75">状態</label>
              <v-select class="w-full"
                        id="update_state"
                        v-model="update_state"
                        placeholder="..."
                        :options="listSelectStateFlag">
              </v-select>
            </div>
            <div style="margin-top:20px">
              <label class="text-sm opacity-75">種別</label>
              <v-select class="w-full"
                        id="update_type"
                        v-model="update_type"
                        placeholder="..."
                        :options="listTypeSelect">
              </v-select>
            </div>
            <div :style="isSpamView ? 'display:none':'margin-top:20px'">
              <label class="text-sm opacity-75">フォルダ</label>
              <v-select class="w-full"
                        id="update_type"
                        v-model="update_folder"
                        placeholder="..."
                        :options="listFolderUpdate">
              </v-select>
           </div>
            <div class="flex justify-end" style="margin-top:70px">
              <vs-button @click="updateMailReceive" color="success" icon="assignment" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
              <vs-button @click="activeConfirm = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
            </div>
        </div> 
      </vs-popup>

      <!-- dialog confirm deleteRule-->
    <vs-popup ref="dialogConfirm" title="仕分けルールが削除されました。" :active.sync="activeDeleteRule" button-close-hidden>
        <div>
          <span>
            選択した仕分けルールを削除しますか？
          </span>
        </div>
        <div class="flex justify-end">
            <vs-button @click="deleteRule" color="danger" icon="delete" style="padding: 8px; margin-right: 5px;height: 37px">削除</vs-button>
            <vs-button @click="activeDeleteRule = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">キャンセル</vs-button>
        </div>
      </vs-popup>

      <!-- dialog confirm apply rule for all mail-->
    <vs-popup title="ルールを適用する" :active.sync="activeApplyRule" button-close-hidden>
        <div>
          <span>
            ルールを前のメールに適用しますか ?
          </span>
        </div>
        <div class="flex justify-end">
            <vs-button @click="applyRule" color="success" icon="check" style="padding: 8px; margin-right: 5px;height: 37px">実行</vs-button>
            <vs-button @click="activeApplyRule = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
        </div>
      </vs-popup>

      <!-- dialog confirm delete signature-->
      <vs-popup title="署名削除" :active.sync="activeDeleteSignature" button-close-hidden>
        <div>
          <span>
            選択した署名を削除しますか？
          </span>
        </div>
        <div class="flex justify-end mt-4">
            <vs-button @click="deleteSignature" icon="delete" color="danger" class="mx-2">削除</vs-button>
            <vs-button @click="activeDeleteSignature = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
        </div>
      </vs-popup>


      <!-- dialog state display -->
    <vs-popup ref="dialogConfirmState" title="表示カスタマイズ" :active.sync="activeStateDisplay" button-close-hidden>
      <div style="height: 100%">
          <ag-grid-vue
            id="myGrid1"
            :components="components"
            :gridOptions="gridOptionsState"
            class="ag-theme-material w-100 my-4 ag-grid-table database"
            :columnDefs="columnDefsState"
            :defaultColDef="defaultColDef"
            :rowData="listStateDisplayComputed"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="false"
            :domLayout="domLayout"
            @grid-ready="onGridReadyState"
            @selection-changed="onSelectionChangedState"
            @rowDragEnd="onSelectionChangedState"
            :suppressPaginationPanel="true"
            :detailRowAutoHeight="true"
          ></ag-grid-vue>
      </div>
      <div class="flex justify-end">
            <vs-button @click="saveStateDisplay" color="success" icon="save" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
            <vs-button @click="activeStateDisplay = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">キャンセル</vs-button>
        </div>
      </vs-popup>

      <!-- dialog Sort Rule-->
    <vs-popup class="fullscreenBox"  title="仕分けルール" :active.sync="activeSortRule" button-close-hidden>
      <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-row mt-3" >
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">対象</label>
                <v-select class="w-full"
                          v-if="activeSortRule"
                          v-validate.immediate="'required'"
                          name="対象"
                          id="subject_rule"
                          v-model="subject_rule"
                          :options="listSubjectRule">
                </v-select>
                <vs-row>
                      <vs-col vs-offset="0">
                        <span v-show="submittedRule" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("対象") | convertError }}</span>
                      </vs-col>
                    </vs-row>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">検索文字列</label>
                <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                          v-if="activeSortRule"
                          v-validate.immediate="'required'"
                          name="検索文字列"
                          id="search_rule"
                          v-model="search_rule">
                </vs-input>
                <vs-row>
                      <vs-col vs-offset="0">
                        <span v-show="submittedRule" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("検索文字列") | convertError }}</span>
                      </vs-col>
                    </vs-row>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">仕分け先</label>
                <v-select class="w-full"
                          v-if="activeSortRule"
                          v-validate.immediate="'required'"
                          name="仕分け先"
                          id="folder_rule"
                          v-model="folder_rule"
                          :options="listFolderReceiveMailComputed">
                </v-select>
                <vs-row>
                      <vs-col vs-offset="0">
                        <span v-show="submittedRule" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("仕分け先") | convertError }}</span>
                      </vs-col>
                    </vs-row>
              </div>
            <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">状態</label>
                <v-select class="w-full"
                          id="state_rule"
                          v-model="state_rule"
                          placeholder="..."
                          :options="listSelectStateFlag">
                </v-select>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">担当者</label>
                <v-select class="w-full"
                          id="manage_rule"
                          v-model="manage_rule"
                          placeholder="..."
                          :options="listMstUserSelectRemoveNotSet">>
                </v-select>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <label class="text-sm opacity-75">種別</label>
                <v-select class="w-full"
                          id="type_rule"
                          v-model="type_rule"
                          placeholder="..."
                          :options="listTypeSelect">
                </v-select>
              </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                <label class="text-sm opacity-75">ルール名</label>
                <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                v-if="activeSortRule"
                v-validate.immediate="'required'"
                          name="ルール名"
                          id="search_rule"
                          v-model="name_rule">
                </vs-input>
                <vs-row>
                      <vs-col vs-offset="0">
                        <span v-show="submittedRule" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("ルール名") | convertError }}</span>
                      </vs-col>
                    </vs-row>
              </div>
            </div>
            <div class="vx-row">
                <div v-for="(item,index) in stateFlgOptions" :key="index">
                    <input  type="radio" v-model="stateOption_name" :value="item" class="mr-1 ml-4" style="position: relative; top: 2px"/>
                    <span>{{item}}</span>
                </div>
            </div>
            <div class="vx-row mt-5">
              <vs-button @click="addRule" color="success"  style="padding: 8px; margin-right: 5px;margin-left: 10px;height: 37px">新規作成</vs-button>
              <vs-button @click="updateRule" :disabled="!ruleSelected" color="warning" style="padding: 8px; margin-right: 5px;height: 37px">更新</vs-button>
              <vs-button @click="activeDeleteRule = true"  :disabled="!ruleSelected" color="danger" style="padding: 8px; margin-right: 5px;height: 37px">削除</vs-button>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <div class="vx-row mt-0">
              <ag-grid-vue
                id="myGridRule"
                :components="components"
                :gridOptions="gridOptionsRule"
                class="ag-theme-material w-100 my-4 ag-grid-table database"
                :columnDefs="columnDefsRule"
                :defaultColDef="defaultColDef"
                :rowData="listRuleComputed"
                rowSelection="single"
                colResizeDefault="shift"
                :animateRows="true"
                :pagination="false"
                :domLayout="domLayout"
                @grid-ready="onGridReadyRule"
                @selection-changed="onSelectionChangedRule"
                :overlayNoRowsTemplate="noRowsTemplate"
                :suppressPaginationPanel="true"
                :detailRowAutoHeight="true"
                style="max-height: 60vh; overflow-y: auto; margin-top: 0px !important;"
              ></ag-grid-vue>
            </div>
            <div class="flex justify-end mt-5">
                <vs-button :disabled="!ruleSelected || enableApplyRuleButton == false" @click="activeApplyRule = true"  color="success"  style="padding: 8px; margin-right: 5px;margin-left: 10px;height: 37px">実行</vs-button>
                <vs-button @click="activeSortRule = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
            </div>
          </div>
        </div>
        
    </vs-popup>

      <!--dialog Signature Management-->
    <vs-popup title="署名一覧" :active.sync="activePopupSignature" button-close-hidden>
      <vx-card style="height: 400px;overflow-y: scroll;scrollbar-width: thin;">
        <div>
          <ag-grid-vue
            id="myGridSignature"
            :components="components"
            :gridOptions="gridOptionsSignature"
            class="ag-theme-material w-100 my-4 ag-grid-table database"
            :columnDefs="columnDefsSignature"
            :defaultColDef="defaultColDef"
            :rowData="listUserSignature"
            rowSelection="multiple"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="false"
            :domLayout="domLayout"
            @grid-ready="onGridReadySignature"
            @selection-changed="onSelectionChangedSignature"
            :suppressPaginationPanel="true"
            :overlayNoRowsTemplate="noRowsTemplate"
            :detailRowAutoHeight="true"
          ></ag-grid-vue>
        </div>
      </vx-card>
      <div class="vx-col w-full mt-4">
        <vs-row>
          <vs-col vs-w="2" class="flex items-center">
            <label class="text-sm opacity-75 ml-6">名前</label>
          </vs-col>
          <vs-col vs-w="10">
          <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                    v-if="activePopupSignature"
                    v-validate.immediate="'required'"
                    name="名前"
                    id="signature_name"
                    v-model="signature_name"
                   >
          </vs-input>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col vs-offset="2">
            <span v-show="submittedSignature" class="mb-2 text-danger font-size-info" style="display: block;">{{ errors.first("名前") | convertError }}</span>
          </vs-col>
        </vs-row>
      </div>
      <div class="flex mt-3 mb-3">
            <vs-button @click="createSignature" :disabled="!validateForm && submittedSignature" color="success"  style="padding: 8px; margin-right: 5px;height: 37px">登録</vs-button>
            <vs-button @click="activeDeleteSignature = true" :disabled="listSignatureSelect.length == 0" color="danger"  style="padding: 8px; margin-right: 5px;height: 37px">削除</vs-button>
            <vs-button @click="editSignature" :disabled="(!validateForm && submittedSignature) || !activeUpdateSignature" color="warning"  style="padding: 8px; margin-right: 5px;height: 37px">保存</vs-button>
      </div>
      <div>
        <select  @change="changeMessage" v-model='modeHTML' class="float-right relative z-10 rounded cursor-pointer">
             <option v-for="select in bodyType" :value="select.value">{{ select.label }}</option>
        </select>
          <quill-editor v-if="modeHTML" v-model="user_signature" :options="editorOption" style="height:150px;margin-bottom:100px"/>
          <vs-textarea id="user_signature_textarea" v-else v-model="user_signature" placeholder="" height='150px'></vs-textarea>
      </div>
      <div class="flex justify-end">
            <vs-button @click="activePopupSignature = false" color="lightgrey" icon="cancel" style="padding: 8px;margin-top:5px; height: 37px;">閉じる</vs-button>
          </div>
    </vs-popup>

    <div class="flex flex-wrap items-center">
      <vs-row class="pb-2"
              style="align-items: center; justify-content: space-between;"
              vs-type="flex">
        <vs-col vs-w="4" class="flex items-center">
          <vs-col style="width: 111px" class="mr-3">
            <vs-switch v-model="modeComputed">
              <span slot="on">プレビュー</span>
              <span slot="off">プレビュー非表示</span>
            </vs-switch>
          </vs-col>
          <vs-col style="width: 200px" class="flex items-center justify-center">
            <div style="width: 35%;">
              表示件数:
            </div>
            <div style="width: 60%">
              <v-select class="square mr-2"
                        id="pagination_limit"
                        v-model="pagination.limit"
                        placeholder="..."
                        :options="listRowLimit"
                        :searchable="false">
              </v-select>
            </div>
          </vs-col>
        </vs-col>
        <vs-col vs-w="8"
                vs-type="flex"
                vs-align="flex-end"
                vs-justify="flex-end">
          <vs-button class="square mr-2"
                   icon="delete"
                   color="danger"
                   @click="!handleInvalidDateRange() && (activeDeletePopUp = true)"
                   :disabled="listMailReceiveSelect.length == 0 || readOnly">
                  <span>削除</span>
          </vs-button>
          <vx-tooltip :color="(listMailReceiveSelect.length == 0 ? 'rgb(255, 255, 255, 0)':'#626262')"
                      :text="statusIsRead ? '既読にする':'未読にする。'"
                      position="bottom">
            <vs-button class="square mr-2"
                      color="#439734"
                      icon="drafts"
                      @click="updateIsReadMail()"
                      :disabled="listMailReceiveSelect.length == 0">
              <span>未読/開封済み</span>
            </vs-button>
          </vx-tooltip>
          <vue-json-to-csv ref="exportCSV" style="display: none" csv-title="MailReceived_CSV" :labels="labelExport" :json-data="dataExport" ></vue-json-to-csv>
          <vs-button class="square mr-2"
                      color="#1976d2" 
                      icon="file_download"
                      @click="onExportCSV"
                      :disabled="listMailReceiveSelect.length == 0" >
            <span>CSV出力</span>
          </vs-button>
          <vs-button class="square mr-2"
                      color="darkgrey"
                      @click="activePopupSignature = true;submittedSignature = false;activeUpdateSignature = false" >
            <span>署名の管理</span>
          </vs-button>
          <vs-button class="square mr-2"
                      :style="isSpamView ? 'display:none':''"
                      :disabled="readOnly"
                      color="#28d4c3"
                      @click="activePopUpSortRule" >
            <span>仕分けルール</span>
          </vs-button>
          <vs-button class="square mr-2"
                      color="#3287bf"
                      :disabled = "modeComputed"
                      @click="activePopupState">
            <span>表示カスタマイズ</span>
          </vs-button>      
          <vs-button class="square mr-2"
                      :disabled="readOnly"
                      color="#F3950D"
                      @click="activeRefetch = true">
            <span>一括取得</span>

            <!----Dialog refetch mail---->
            <vs-popup title="一括取得" :active.sync="activeRefetch" button-close-hidden>
              <vs-row vs-w="12" vs-type="flex" vs-justify="space-between">
                <vs-col vs-w="5.75">
                  <label class="text-sm opacity-75">から</label>
                  <flat-pickr id="refetch_from_date"
                              class="w-full flatpickr-style"
                              v-model="refetch_from_date"
                              placeholder="..."
                              :config="configDate">
                  </flat-pickr>
                </vs-col>
                <vs-col vs-w="5.75">
                  <label class="text-sm opacity-75">まで</label>
                  <flat-pickr id="refetch_to_date"
                              class="w-full flatpickr-style"
                              v-model="refetch_to_date"
                              placeholder="..."
                              :config="configDate">
                  </flat-pickr>
                </vs-col>
              </vs-row>
              <div class="flex justify-end mt-4">
                  <vs-button @click="refetch" icon="check" color="success" class="mx-2">はい</vs-button>
                  <vs-button @click="activeRefetch = false" icon="cancel" color="lightgrey">キャンセル</vs-button>
              </div>
            </vs-popup>
          </vs-button>
          <vs-button class="square"
                     color="#66e0ff"
                     @click="!handleInvalidDateRange() && (activeConfirm = true)"
                     :disabled="listMailReceiveSelect.length == 0 || readOnly">
            <span>一括更新</span>
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
    
    <!-- AgGrid Table -->
    <div v-if="!modeComputed">
      <ag-grid-vue
          id="myGrid"
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table database ag-grid-customize"
          :columnDefs="modifiedColumnsDefs"
          :defaultColDef="defaultColDef"
          :rowData="listMailReceivedComputed"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :domLayout="domLayout"
          :paginationPageSize="paginationPageSize"
          :isRowSelectable="isRowSelectable"
          @sort-changed="onSortChanged"
          @grid-ready="onGridReady"
          @row-selected="rowClickChanged"
          :enableRtl="$vs.rtl"
          :overlayNoRowsTemplate="noRowsTemplate"
          :suppressPaginationPanel="true"
          :detailRowAutoHeight="true"
          :getRowStyle="getRowStyle">
      </ag-grid-vue>
      <div style="position: relative">
        <!-- ITEMS PER PAGE -->
          <div>
              <div class="flex items-center justify-between">
                <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
              </div>
          </div>
          <vs-pagination
            v-if="listMailReceived.length > 0"
            :total="pagination.totalPage"
            :max="7"
            v-model="pagination.currentPage"
            class="pt-10 pr-10"
          />
      </div>
    </div>
    <!--Preview mode-->
    <vs-row v-else vs-type="flex" vs-justify="space-between">
      <vs-col vs-w="4">
        <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptionsPreview"
            class="ag-theme-material w-100 my-4 ag-grid-table database overflow-y-auto ag-grid-customize"
            :columnDefs="previewModeColumnDefs"
            :defaultColDef="defaultColDef"
            :rowData="listMailReceivedComputed"
            rowSelection="single"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            :domLayout="domLayout"
            :paginationPageSize="paginationPageSize"
            :isRowSelectable="() => true"
            @sort-changed="onSortChanged"
            @grid-ready="onGridReady"
            @selection-changed="onPreviewModeSelectionChanged"
            :enableRtl="$vs.rtl"
            :overlayNoRowsTemplate="noRowsTemplate"
            :suppressPaginationPanel="true"
            :detailRowAutoHeight="true"
            :getRowHeight="getRowHeight"
            :isFullWidthCell="isFullWidthCell"
            :fullWidthCellRenderer="fullWidthCellRenderer"
            style="max-height: 912px;"
            :getRowStyle="getRowStyle"
            >
        </ag-grid-vue>

        <div style="position: relative">
          <!-- ITEMS PER PAGE -->
            <div>
                <div class="flex items-center justify-between">
                  <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                </div>
            </div>
            <vs-pagination
              v-if="listMailReceived.length > 0"
              :total="pagination.totalPage"
              :max="7"
              v-model="pagination.currentPage"
              class="pt-10 pr-10"
            />
        </div>
      </vs-col>

      <!--Preview section-->
      <vs-col vs-w="7.75" id="receive-mail-detail" >
          <vs-row class="mt-5  py-2"
                vs-type="flex"
                vs-align="flex-end"
                vs-justify="flex-end">
              <vs-button class="square"
                    color="#4478b8"
                    @click="editReceiveMailDetail(receive_mail.id)"
                    :disabled = "!receive_mail.inquiry_id"
                    >
                <span><feather-icon icon="EditIcon" class="cursor-pointer" svg-classes="h-6 w-6"></feather-icon></span>
                <img hidden id="img-error" src="@/assets/images/other-icons/error.png"/>
              </vs-button>
          </vs-row>

          <vs-row>
            <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>ID</span>
                  </div>
                </template>
                <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="receive_mail.inquiry_id" placeholder="inquiry_id" />
              </vx-input-group>
            </vs-col>
            <vs-col>
              <vx-input-group class ="square" type="file">
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>From</span>
                  </div>
                </template>
                <vs-input :readonly="isFormInValid" :class="isFormInValid ? 'disabled-input' : ''" v-model="receive_mail.email_sender_full" placeholder="email_sender_full" />
              </vx-input-group>
            </vs-col>
            <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>To</span>
                  </div>
                </template>

                <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="receive_mail.to" placeholder="" />
              </vx-input-group> 
            </vs-col>
            <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>CC</span>
                  </div>
                </template>

                <vs-input :readonly="isFormInValid" :class="isFormInValid?'disabled-input':''" v-model="receive_mail.cc" />
              </vx-input-group> 
          </vs-col>
          <vs-col class="mt-5" v-if="receive_mail.error_detail">
            <div class="prepend-text label-style w-full" style="padding:10px">
              <span class="mr-5"><img src="@/assets/images/other-icons/error.png" style="position: relative;top: 3px;"/></span>
              <span>エラー内容</span>
            </div>
            <vx-card
              class="card-body-mail"
              no-radius
              cardBorder
              :class="isFormInValid ? 'disabled-input' : ''"
            >
              <div
                class="w-full"
                v-html="receive_mail.error_detail"
                style="height: 150px; overflow-y: scroll"
              ></div>
            </vx-card>
          </vs-col>
          <vs-col class="mt-5" style="border: solid 1px #E2E2E2">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text label-style" style="width: 120px">
                  <span>添付ファイル</span>
                </div>
              </template>
              <vs-row>
                <vs-col
                  style="width: max-content; padding: 3px 5px"
                  :key="index"
                  v-for="(value, index) in receive_mail.attachmentFileName"
                >
                  <div @click="downloadAttachment(value.path)">
                    <vs-chip
                      style="cursor: pointer"
                      class="mt-1"
                      color="dark"
                      transparent
                      >{{ value.file_name }}</vs-chip
                    >
                  </div>
                </vs-col>
              </vs-row>
            </vx-input-group>
          </vs-col>
        </vs-row>

        <vs-row class="mt-6">
          <vx-card
            class="card-body-mail"
            no-radius
            cardBorder
            noShadow
            title="件名"
            :class="isFormInValid ? 'disabled-input' : ''"
          >
            <div
              class="w-full"
              v-html="receive_mail.subject"
              style="padding: 9.8px"
            ></div>
          </vx-card>

          <vx-card
            class="card-body-mail"
            no-radius
            cardBorder
            noShadow
            title="お問い合わせ本文"
            :class="isFormInValid ? 'disabled-input' : ''"
          >
            <div
            id="receiveMailBodyBlock"
              class="pl-2 pt-2"
              v-if="receive_mail.body_type == 0"
              v-html="receive_mail.body"
              style="height: 560px; overflow-y: scroll"
            ></div>
            <vs-textarea
            id="receiveMailBodyTextarea"
              v-else
              :readonly="isFormInValid"
              v-model="receive_mail.body"
              placeholder="..."
              height="560px"
            />
          </vx-card>
        </vs-row>
      </vs-col>
    </vs-row>
    <!-- dialog confirm delete-->
    <vs-popup ref="dialogConfirm" title="受信を削除" :active.sync="activeDeletePopUp" button-close-hidden>
        <div>
        <span>
          選択した受信を削除しますか？
        </span>
        </div>
        <div class="flex justify-end">
            <vs-button @click="deleteSelect" color="danger" icon="delete" style="padding: 8px; margin-right: 5px;height: 37px">はい</vs-button>
            <vs-button @click="activeDeletePopUp = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
        </div>
    </vs-popup>
  </div>
</template>
<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
import { AgGridVue } from "ag-grid-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CellRendererActions from "@/components/cell-renderer/CellRendererActions";
import CellRendererCheckbox from "@/components/cell-renderer/CellRendererCheckbox";
import CellRendererError from "@/components/cell-renderer/CellRendererError";
import CellRendererPriority from "@/components/cell-renderer/CellRendererPriority";
import EventBus from "../EventBus";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import Vue from "vue";
import {getLS} from "../utils/localStorage-utils";
import {handleDownloadAttachment, setupIconClickEvent, notifyEmptyReceive, notifyInquiryPeriodLimit, getDateRange } from "@/utils/helpler-utils";
import htmlToFormattedText  from 'html-to-formatted-text';
import {Html5Entities} from "html-entities";
import {htmlToText} from "html-to-text";
import VueJwtDecode from 'vue-jwt-decode';
Vue.component('cell-action',CellRendererActions)
Vue.component('cell-error',CellRendererError)
Vue.component('cell-priority',CellRendererPriority)

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererActions,
    CellRendererCheckbox,
    quillEditor,
    CellRendererError,
    CellRendererPriority,
    htmlToFormattedText,
    Html5Entities,
    htmlToText
  },
  data() {
    return {
      iconVsInput:'close',
      bodyType : [
        {
          label : 'Text 形式',
          value : false
        },
        {
          label : 'HTML 形式',
          value : true
        }
      ],
      isCreated: true,
      activeConfirm: false,
      activeStateDisplay: false,
      receive_date_search_from: "",
      receive_date_search_to: "",
      email_sender_search: "",
      response_date_search: "",
      inquiry_id_search: "",
      mst_user_search: {
        value: "",
        label: "...",
      },
      receive_mail__email_sender_search: "",
      to_search__email_sender_search: "",
      cc_search__email_sender_search: "",
      customer_domain_search: null,
      list_customer_select_res: [
        {
          value: null,
          label: "..."
        }
      ],
      listCustomerSelect: [],
      state_flg_search: {
        value: "",
        label: "...",
      },
      inquiry_type_search: {
        value: "",
        label: "...",
      },
      subject_search: "",
      body_search: "",
      type_search: {
        value: "",
        label: "...",
      },
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: "",
      },
      listSentUserNameSelect: ["..."],
      listMstUserSelect: [
        {
          label: "...",
          value: "",
        },
      ],
      listInquiryTypeSelect: [
        {
          label: "...",
          value: "",
        },
        {
          label: "メール",
          value: "0",
        },
        {
          label: "電話",
          value: "1",
        },
        {
          label: "営業",
          value: "2",
        },
        {
          label: "その他",
          value: "9",
        },
      ],
      listMailReceiveSelect: [],
      listSelectStateFlag: [
        {
          label: "...",
          value: "",
        },
        {
          value: 0,
          label: "未対応",
        },
        {
          value: 1,
          label: "対応中",
        },
        {
          value: 2,
          label: "返信済（回答待ち）",
        },
        {
          value: 3,
          label: "返信済",
        },
        {
          value: 4,
          label: "完了",
        },
      ],
      listTypeSelect: ["..."],
      priority_search: null,
      listPriority: [
        {
          label: "...",
          value: null
        },
        {
          label: "未設定",
          value: 0
        },
        {
          label: "低",
          value: 1
        },
        {
          label: "中",
          value: 2
        },
        {
          label: "高",
          value: 3
        },
      ],
      startRow: 0,
      endRow: 0,
      pagination: {
        totalPage: 0,
        currentPage:
          this.searchFilter &&
          this.searchFilter.queries &&
          this.searchFilter.queries.page
            ? this.searchFilter.queries.page
            : 1,
        limit: 10,
        totalItem: 0,
        from: 1,
        to: 10,
      },
      orderBy: "receive_datetime",
      orderDir: "desc",

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: "autoHeight",
      gridApi: null,
      gridColumnApi: null,
      columnApi: null,
      isRowSelectable: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
        onCellClicked: (cell) => {
          if (cell.value !== undefined){
            this.editReceiveMailDetail(cell.data.id)
          }
        },
        suppressRowClickSelection: true,
        getRowClass: () => {
          if (this.isSpamView) {
              return 'hidden-drag';
          }
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ["asc", "desc"],
      },
      headerCheckbox: {
        width: 40,
        filter: true,
        checkboxSelection: (params) => {
          // let data = params.data;
          // if (data && data.mst_user_id === null && data.state_flg === 0) {
          //   return true;
          // } else {
          //   return false;
          // }
          return true;
        },
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true,
        cellRendererFramework: "CellRendererCheckbox",
        cellRendererParams: {
          notSetup: true,
        },
        suppressMovable: true,
        // resizable: false
      },
      dragAction: {
        width: 30,
        filter: true,
        dndSource: true,
        dndSourceOnRowDrag: this.onRowDrag,
      },
      headerError:{
        headerName: "",
        width: 40,
        cellRendererFramework: "cell-error",
        suppressMovable: true,
      },
      columnDefs: [
        {
          width: 30,
          filter: true,
          dndSource: true,
          dndSourceOnRowDrag: this.onRowDrag,
        },
        {
          width: 40,
          filter: true,
          checkboxSelection: (params) => {
            // let data = params.data;
            // if (data && data.mst_user_id === null && data.state_flg === 0) {
            //   return true;
            // } else {
            //   return false;
            // }
            return true;
          },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          cellRendererFramework: "CellRendererCheckbox",
          cellRendererParams: {
            notSetup: true,
          },
          suppressMovable: true,
          // resizable: false
        },
        {
          headerName: "",
          width: 40,
          cellRendererFramework: "cell-error",
          suppressMovable: true,
        },
        {
          headerName: "分類",
          field: "matching_status",
          width: 75,
          unSortIcon: false,
          sortable: false,
          suppressMovable: true,
        },
        {
          headerName: "方法",
          field: "inquiry_type_text",
          width: 75,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "お問い合わせ日",
          field: "receive_datetime",
          width: 150,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "回答期日",
          field: "response_limit",
          width: 100,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "担当者",
          field: "full_name",
          width: 150,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "状態",
          field: "state_flg_text",
          width: 130,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "種別",
          field: "type_text",
          width: 100,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "優先度",
          field: "priority",
          width: 60,
          cellRendererFramework: "cell-priority",
          suppressMovable: true,
        },
        {
          headerName: "お問い合わせID",
          field: "inquiry_id",
          width: 150,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "お問い合わせ者",
          field: "email_sender_full_table",
          width: 200,
          // cellClass: 'text-center',
          sortable: false,
          suppressMovable: true,
        },
        {
          headerName: "タイトル",
          field: "subject",
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "メール本文",
          field: "parsed_body",
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "送信済み",
          field: "check_replied_mail",
          width: 100,
          sortable: false,
          suppressMovable: true,
          cellClass: 'text-center',
        },
        {
          headerName: "保存先フォルダ",
          field: "folder",
          width: 110,
          unSortIcon: true,
          sortable: true,
          suppressMovable: true,
        },
      ],
      type_mail: 0, //'0: 受信 | 1:送信'
      gridApiState: null,
      columnApiState: null,
      listStateDisplaySelect: [
        "分類",
        "方法",
        "お問い合わせ日",
        "回答期日",
        "担当者",
        "状態",
        "種別",
        "優先度",
        "お問い合わせID",
        "お問い合わせ者",
        "タイトル",
        "メール本文",
        "送信済み",
        "保存先フォルダ",
      ],
      data_display: [],
      gridOptionsState: {
        rowDragManaged: true,
        suppressRowClickSelection: true,
      },
      columnDefsState: [
        {
          headerName: "",
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "表示順",
          width: 100,
          rowDrag: true,
          suppressSorting: true,
        },
        {
          headerName: "ヘッダ名称",
          field: "content",
          width: 400,
          suppressSorting: true,
        },
      ],
      sort_display: [],
      list_state_display_default: [
        { content: "分類"},
        { content: "方法" },
        { content: "お問い合わせ日" },
        { content: "回答期日" },
        { content: "担当者" },
        { content: "状態" },
        { content: "種別" },
        { content: "優先度" },
        { content: "お問い合わせID" },
        { content: "お問い合わせ者" },
        { content: "タイトル" },
        { content: "メール本文" },
        { content: "送信済み" },
        { content: "保存先フォルダ" },
      ],
      // Cell Renderer Components
      components: {
        CellRendererActions,
      },

      //Refetch mail
      activeRefetch: false,
      refetch_to_date: "",
      refetch_from_date: "",

      //Mode
      gridOptionsPreview: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
      },
      previewModeColumnDefs: [
        {
          headerName: "",
          field: "receive_datetime",
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],
      rowNode: [],
      getRowHeight: null,
      fullWidthCellRenderer: null,
      isFullWidthCell: null,
      isFormInValid: true,

      //SortRule
      submittedRule: false, // true : show error validate
      subject_rule: null,
      search_rule: '',
      manage_rule: null,
      type_rule: null,
      state_rule: null,
      folder_rule: null,
      stateFlgOptions: [
        '有効','無効'
      ],
      stateOption_name: '有効',
      name_rule: null,
      activeSortRule: false, //false: hide popup, true: show popup
      listSubjectRule: [
        {
          label: "タイトル",
          value: 0,
        },
        {
          label: "本文",
          value: 1,
        },
        {
          label: "FROM",
          value: 2,
        },
        {
          label: "TO",
          value: 3,
        },
        {
          label: "CC",
          value: 4,
        },
      ],
      gridOptionsRule: {
        onGridSizeChanged: () => {
          this.gridApiRule.sizeColumnsToFit();
        },
      },
      gridApiRule: null,
      columnApiRule: null,
      columnDefsRule: [
        {
          headerName: "",
          width: 50,
          checkboxSelection: true,
        },
        {
          headerName: "ルール名",
          field: "name",
          width: 400,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "状態",
          field: "state_flg",
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],
      ruleSelected: null,
      activeDeleteRule: false, //false: hide popup, true: show popup
      activeApplyRule: false, //false: hide popup, true: show popup
      enableApplyRuleButton: false,
      //Callback Request
      callRequest: '',
      //Read-only
      readOnly: false,
      //Update Receive Mail
      update_mst_user: null,
      update_state: null,
      update_type: null,
      update_folder: null,
      //Signature Management
      activePopupSignature: false, // false: hide popup, true: show popup
      activeDeleteSignature: false, // false: hide popup, true: show popup
      gridApiSignature: null,
      columnApiSignature: null,
      columnDefsSignature:[
        {
          headerName: "",
          width: 50,
          checkboxSelection: true,
        },
        {
          headerName: "名前",
          field: "signature_name",
          width: 400,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "",
          field: "transactions",
          width: 50,
          cellRendererFramework: "cell-action",
          cellRendererParams: {
            hideDelete: true,
          },
          unSortIcon: false,
          suppressMovable: true,
          resizable: false,
        },

      ],
      gridOptionsSignature: {
        onGridSizeChanged: () => {
          this.gridApiSignature.sizeColumnsToFit();
        },
        suppressRowClickSelection: true,
      },
      signature_name: '',
      modeHTML: true, //true: HTML, false: plain text
      user_signature: '',
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],

            [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'font': [] }],
            [{ 'align': [] }],

            ['clean'],                                         // remove formatting button

            ['link', 'image', 'video']                         // link and image, video
          ]
        },
        placeholder: ''
      },
      listSignatureSelect: [],
      submittedSignature: false,
      activeUpdateSignature: false,

      //Define list Mst_user remove not set(未設定)
      listMstUserSelectRemoveNotSet: [
        {
          label: "...",
          value: "",
        },
      ],
      //CheckMultiple v-Select
      checkIsMultiple: {
        state_flg: false,
        mst_user : false,
        type     : false,
      },
      selectedReceiveMail: {},
      pollingNotification: null,
      showNotification: null,
      listNotifications : [],
      //Search SubFoler
      searchSubFolder: false,
      //Export CSV
      dataExport: [],
      labelExport: {},
      //Mail Spam View
      isSpamView: false, //true: show spam mail

      //PAC_21-91
      listRowLimit: [
        '10',
        '25',
        '50'
      ],
      statusIsRead: false, // read, unread
      activeDeletePopUp: false,
      isRollingBack: false,
    };
  },
  watch: {
    'pagination.limit': function (newVal, oldVal) {
      const isDateRangeExceeded = this.handleInvalidDateRange(() => {
          this.$nextTick(() => {
              this.pagination.limit = oldVal;
          });
      });
      if (isDateRangeExceeded) return;

      this.pagination.currentPage = 1;
      this.onSearch(false);
    },
    async $route(to, from) {
      /* start loading with many requests */
      this.$store.dispatch("updateLoads", true);
      this.clearSearchFilter();
      let mailBox = this.$route.params.email;
      let folder = null;
      if (this.$route.fullPath.includes("folder") == true) {
        folder =
          this.$route.fullPath.split("/")[
            this.$route.fullPath.split("/").length - 1
          ];
      }
      if (mailBox) {
      } else if (this.listMailBox && this.listMailBox.length > 0) {
        mailBox = this.listMailBox[0].receive_user_name;
      }
      if (mailBox) {
        this.clearSearchOption();
        this.orderBy = "receive_datetime";
        this.orderDir = "desc";
        this.gridApi.setSortModel({ colId: "receive_datetime", sort: "desc" });
        if (this.$route.name === "spam") {
          this.isSpamView = true;
        } else {
          this.isSpamView = false;
          this.handleSearchSubFolder();
        }
        if (this.callRequest != this.$route.params.email){
          this.listNotifications = [];
          let mailBoxInfo = await this.listMailBox.find(
              (element) => element.receive_user_name == this.$route.params.email
          );
          let params = null;
          if (mailBoxInfo) {
            params = {
              mst_mail_server_id: mailBoxInfo.id,
            };
          }else{
            params = {};
          }

          let response = await this.getMasterData(params);
          if (response){
            if (mailBoxInfo){
              this.getListMstUserSelect(response.listUserSelect);
            }
            this.getListMailSendUserSelect(response.listMailServerSentUser);
            this.getListKindsSelect(response.listKindsSelect);
            this.getCustomerLinked(response.customerLinked);
          }

          //TODO 21-13
          await this.getListMailBox();
          await this.getFolderReceiveMail(mailBox);
          await this.getRuleReceiveMail(mailBox);
          this.readOnly = await this.setUserReadOnly(mailBox) > 0;
          this.callRequest = this.$route.params.email;
        }
        //Refresh v-select multiple
        this.checkIsMultiple = {
          state_flg: false,
          mst_user : false,
          type     : false,
        }
        await this.onSearch(true, null, mailBox, folder);
      }

      /* stop loads */
      this.$store.dispatch("updateLoads", false);
    },
    inquiry_id_search(val) {
      if (val < 0) return (this.inquiry_id_search = null);
    },
    "pagination.currentPage": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        const isDateRangeExceeded = this.handleInvalidDateRange(() => {
            this.$nextTick(() => {
                this.pagination.currentPage = oldVal;
            });
        });
        if (isDateRangeExceeded) return;

        if (!this.isCreated) this.paginationPage(val);
      },
    },

    //change customer matched when date_from change
    receive_date_search_from(){
      this.customer_domain_search = null;
      let timeStart = new Date(this.receive_date_search_from);
      let listCompare = this.list_customer_select_res.filter(item => item.value == null || item.receive_mail === this.$route.params.email);
      this.listCustomerSelect = listCompare.filter(customer => customer.value == null
          || (new Date(customer.matched_at)).getTime() >= timeStart.getTime()
      );
    },
    searchSubFolder(){
      //Get Info User Login
      let userInfo = JSON.parse(getLS("userInfo"));
      //Get data include sub folder
      let listIncludeSubFolder = JSON.parse(this.listIncludeSubFolder);
      // Check state of user exist
      let result = listIncludeSubFolder.filter(item => item.id == userInfo.id);
      let setInclude = {}
      if (this.searchSubFolder && result) {
        if (result.length == 0) {
          //New state
          setInclude.id = userInfo.id;
          setInclude.mail_server = [this.$route.params.email]
        } else {
          //Add state
          setInclude.id = userInfo.id;
          result[0].mail_server.push(this.$route.params.email);
          setInclude.mail_server =  result[0].mail_server;
          listIncludeSubFolder = listIncludeSubFolder.filter(item => item.id !== userInfo.id)
        }
        listIncludeSubFolder.push(setInclude);
      } else if (!this.searchSubFolder && result) {
        if (result.length > 0) {
          //Update state
          setInclude.id = userInfo.id;
          let filterMailServer = result[0].mail_server.filter(item => item !== this.$route.params.email);
          setInclude.mail_server = filterMailServer
          listIncludeSubFolder = listIncludeSubFolder.filter(item => item.id !== userInfo.id)
          listIncludeSubFolder.push(setInclude);
        }
      }
      //Save state
      this.$store.commit("receiveMail/SET_LIST_INCLUDE_SUBFOLER", JSON.stringify(listIncludeSubFolder))
    },
  },
  beforeMount() {
    (this.isRowSelectable = (params) => {
      // let data = params.data;
      // if (data && data.mst_user_id === null && data.state_flg === 0) {
      //   return true;
      // } else {
      //   return false;
      // }
      return true;
    }),
      (this.isFullWidthCell = (rowNode) => {
        if (this.mode == true) {
          return rowNode.data;
        }
      }),
      (this.fullWidthCellRenderer = (params) => {
        let cellClass = "cell-full-width ";
        const eDiv = document.createElement("div");
        const eSrcImg = params.data.error_detail ? document.getElementById("img-error").getAttribute("src") : "";
        eDiv.innerHTML = `<div class=${cellClass}>
          <div class="mail-header">
            <span><img src="${eSrcImg}"/></span>
            <span>${params.data.email_sender}</span>
            <span>${params.data.receive_datetime}</span>
          </div>
          <br><span style="font-size:15px; line-height: 1.5">${params.data.subject}</span></div>
        </div>`;
        // '<div class=' + cellClass +'><br><span>' + params.data.email_sender + '</span><span>' + params.data.receive_datetime +'</span><br><br><span style="font-size:15px; line-height: 1.5">' + params.data.subject + '</span></div>'
        return eDiv.firstChild;
      });
    this.getRowHeight = () => {
      if (this.mode == true) {
        return 85;
      } else {
        return 50;
      }
    };
  },
  computed: {
    ...mapGetters({
      listMailBox: "receiveMail/listMailBox",
      listMailReceived: "receiveMail/listMailReceived",
      currentMailBoxSelected: "receiveMail/currentMailBoxSelected",
      searchFilter: "receiveMail/getSearchFilter",
      listUserSetting: "userSetting/listUserSetting",
      mode: "receiveMail/mode",
      listFolderReceiveMail: "mailRule/listFolderReceiveMail",
      listRuleReceiveMail: "mailRule/listRuleReceiveMail",
      listUserSignature: "userSignature/listUserSignature",
      listIncludeSubFolder: "receiveMail/listIncludeSubFolder"
    }),
    paginationPageSize() {
      // if (this.gridApi) return this.gridApi.paginationGetPageSize();
      // else return 10;
      return this.pagination.limit
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    totalRow() {
      return parseInt(this.pagination.totalItem);
    },
    listMailReceivedComputed() {
      let listMailReceived = [];
      this.listMailReceived.forEach((element) => {
        let parsed_body = "";
        parsed_body = element.parsed_body ? element.parsed_body.trim() : "";
        
        if(element.email_sender_full_table == "" || element.email_sender_full_table == null) {
          element.email_sender_full_table = element.email_sender;
        }
        listMailReceived.push(
          Object.assign({ ...element, parsed_body: parsed_body, folder: element.folder_path })
        );
      });
      return listMailReceived;
    },
    listStateDisplayComputed() {
      let listStateDisplay = [];
      if (
        !this.listUserSetting ||
        this.listUserSetting.length == 0 ||
        !this.listUserSetting.sort_display
      )
        listStateDisplay = this.list_state_display_default;
      else {
        if(!this.listUserSetting.sort_display.includes('送信済み')){
          this.listUserSetting.sort_display = this.listUserSetting.sort_display + '送信済み;';
        }
        if(!this.listUserSetting.sort_display.includes('保存先フォルダ')){
          this.listUserSetting.sort_display = this.listUserSetting.sort_display + '保存先フォルダ;';
        }
        let list = this.listUserSetting.sort_display.split(";");
        list.forEach((element) => {
          if (element != "") {
            listStateDisplay.push(Object.assign({ content: element }));
          }
        });
      }
      return listStateDisplay;
    },

    modifiedColumnsDefs() {
      let modifiedColumnsDefs = [];
      if (!this.listUserSetting || this.listUserSetting.length == 0)
        modifiedColumnsDefs = this.columnDef;
      else {
        let modifiedColumns = this.columnDefs;
        let listModified = this.listUserSetting.header_display.split(";");
        listModified.forEach(function (modify, index) {
          modifiedColumns.forEach(function (column, index) {
            if (column.headerName == modify && modify != "") {
              modifiedColumnsDefs.push(column);
            }
          });
        });
        if (modifiedColumnsDefs.length > 0) {
          modifiedColumnsDefs.unshift(this.headerError);
          modifiedColumnsDefs.unshift(this.headerCheckbox);
          modifiedColumnsDefs.unshift(this.dragAction);
        }
      }
      return modifiedColumnsDefs;
    },
    receive_mail() {
      if (this.selectedReceiveMail && (!this.selectedReceiveMail.email_sender_full || this.selectedReceiveMail.email_sender_full == "")) {
        this.selectedReceiveMail.email_sender_full = this.selectedReceiveMail.email_sender
      }
      return this.selectedReceiveMail ? this.selectedReceiveMail : {};
    },
    modeComputed: {
      get() {
        return this.mode;
      },
      async set() {
        this.listMailReceiveSelect = [];
        await this.setMode();
      },
    },
    validateForm(){
      return !this.errors.any()
    },
    listFolderReceiveMailComputed(){
      let listFolder = [];
      if ( !this.listFolderReceiveMail || this.listFolderReceiveMail.length == 0){
        listFolder = [{ label : "", value : null}]
      }
      else{
        listFolder = []
        this.listFolderReceiveMail.forEach(function (folder, index){
        listFolder.push(Object.assign({
        label : folder.name, value : folder.id}));
        });
      }
      return listFolder;
    },
    listRuleComputed(){
      let listRuleData = []
      if ( !this.listRuleReceiveMail || this.listRuleReceiveMail.length == 0 ){
        listRuleData = []
      }
      else{
        listRuleData = []
        this.listRuleReceiveMail.forEach((element) => {
        listRuleData.push(Object.assign({
          ...element, state_flg : element.state_flg == 1 ? '有効' : '無効'}));
        });
      }
      return listRuleData
      
    },
    listFolderUpdate(){
      let listFolderUpdate = [];
      if ( !this.listFolderReceiveMail || this.listFolderReceiveMail.length == 0){
        listFolderUpdate = [{ label : "...", value : null}]
      }
      else{
        listFolderUpdate = [];
        this.listFolderReceiveMail.forEach(folder =>{
          listFolderUpdate.push(Object.assign({
            label : folder.name, value : folder.id}));
        });
        listFolderUpdate.unshift({label : "受信", value : 0});
        listFolderUpdate.unshift({label : "...", value : null});
      }
      return listFolderUpdate;
    }
  },
  methods: {
    ...mapActions({
      getMailReceive: "receiveMail/getMailReceive",
      getListUserDataSelect: "receiveMail/getListUserDataSelect",
      getListMailServerSentUser: "receiveMail/getListMailServerSentUser",
      getListKinds: "kinds/getListKinds",
      updateMailReceived: "receiveMail/updateMailReceived",
      updateIsReadMailReceived:"receiveMail/updateIsReadMailReceived",
      getListMailBox: "receiveMail/getListMailBox",
      clearSearchFilter: "receiveMail/clearSearchFilter",
      clearSearchFilterSend: "mailSent/clearSearchFilter",
      getListCC: "receiveMail/getListCC",
      getListTo: "receiveMail/getListTo",
      getListCustomerLinked: 'customer/getCustomerLinkedDomain',
      refetchMailReceive: "receiveMail/refetchMailReceive",
      setReload: "setReload",
      saveUserSetting: "userSetting/saveUserSetting",
      getUserSetting: "userSetting/getUserSetting",
      refreshUserSetting: "userSetting/refreshUserSetting",
      getSelectedMailPreviewMode: "moduleEmail/getSelectedMailPreviewMode",
      setMode: "receiveMail/setMode",
      downloadFile: "receiveMail/downloadAttachment",
      getFolderReceiveMail: "mailRule/getFolderReceiveMail",
      addRuleReceiveMail: "mailRule/addRuleReceiveMail",
      getRuleReceiveMail: "mailRule/getRuleReceiveMail",
      deleteRuleReceiveMail: "mailRule/deleteRuleReceiveMail",
      fetchRule: "mailRule/fetchRule",
      updateRuleReceiveMail: "mailRule/updateRuleReceiveMail",
      applyRuleReceiveMail: "mailRule/applyRuleReceiveMail",
      setUserReadOnly: "receiveMail/setUserReadOnly",
      getUserSignature: "userSignature/getUserSignature",
      createUserSignature: "userSignature/createUserSignature",
      deleteUserSignature: "userSignature/deleteUserSignature",
      updateUserSignature: "userSignature/updateUserSignature",
      getNotifications: "notification/getNotifications",
      getDataExportCSV: "receiveMail/getDataExportCSV",
      getMasterData: "mailBox/getMasterData",
      deleteMailReceive: "receiveMail/deleteMailReceive",
      handleGetByUid: "loginModule/handleGetByUid",
    }),
    ...mapMutations({
      setSearchFilter: "receiveMail/SET_SEARCH_FILTER",
      setSelectedMailFolder: "mailFolder/SET_SELECTED_MAIL_FOLDER",
    }),
    clearInput(modelExpression) {
      this[modelExpression] = ""; // Clear the value input
    },
    changeMessage(){
      if(!this.modeHTML){
        this.user_signature = this.user_signature.split('</p><p>')
        this.user_signature = this.user_signature.join("\n")
        this.user_signature = this.user_signature.split('&nbsp;')
        this.user_signature = this.user_signature.join(" ")
        this.user_signature = DOMPurify.sanitize(this.user_signature,{USE_PROFILES: {html: false}});
      }else{
        this.user_signature = Html5Entities.encode(this.user_signature)
        this.user_signature = this.user_signature.split('\n')
        this.user_signature = this.user_signature.join('\n<br/>')
        this.user_signature = this.user_signature.split(' ')
        this.user_signature = this.user_signature.join('&nbsp;')
        this.user_signature = this.user_signature + '<p><br></p>'
      }
    },
    pressEnterSearch(){
      this.onSearch(true)
    },
    clearFocusTypeDropdown() {
      this.$nextTick(() => {
        document.activeElement.blur()
        document.getElementById('user_list_filters').focus()
      });
    },
    async paginationPage(value) {
      this.pagination.currentPage = value;
      let mailBox = this.$route.params.email;
      let folder = null;
      if (this.$route.fullPath.includes("folder") == true) {
        folder =
          this.$route.fullPath.split("/")[
            this.$route.fullPath.split("/").length - 1
          ];
      }
      if (mailBox) {
      } else if (this.listMailBox && this.listMailBox.length > 0) {
        mailBox = this.listMailBox[0].receive_user_name;
      }
      await this.onSearch(false, null, mailBox, folder);
    },
    async updateMailReceive() {
      if (this.listMailReceiveSelect && this.listMailReceiveSelect.length > 0) {
        let data = await this.renderDataUpdateMail();
        if (!data.update_mst_user && data.update_state != 0 && data.update_state){
          this.$vs.notify({
            position: 'bottom-right',
            text: '担当者が入力していないため、お問い合わせ詳細の更新に失敗しました。',
            color: 'danger'
          })
        }
        else{
          let listIdSelected = this.listMailReceiveSelect.map(mail => mail.id);
          let params = {
          receive_mail_ids: listIdSelected,
          mst_user        : data.update_mst_user,
          state_flg       : data.update_state,
          type            : data.update_type,
          folder          : data.update_folder,
          };
          await this.updateMailReceived(params);
          this.listMailReceiveSelect = [];
          await this.onSearch(false);
          this.activeConfirm = false;
          await this.getListMailBox();
        }
        
      }
    },
    async updateIsReadMail() {
      if (this.handleInvalidDateRange()) return;
      if (this.listMailReceiveSelect && this.listMailReceiveSelect.length > 0) {
        let listIdSelected = this.listMailReceiveSelect.map(mail => mail.id);
        let params = {
          receive_mail_ids: listIdSelected,
          is_read: this.statusIsRead
        };

        await this.updateIsReadMailReceived(params);
        this.listMailReceiveSelect = [];
        await this.onSearch(false);
        await this.getListMailBox();
      }
    },
    async renderDataUpdateMail(){
       let update_mst_user = null
       let update_state    = null
       let update_type     = null
       let update_folder   = null
       let data_update     = {}
       this.listMstUserSelectRemoveNotSet.map((element)=>{
        if (this.update_mst_user){
          if (this.update_mst_user.label == element.label && element.label != '...'){
            update_mst_user = element.value
          }
        }
      })
       this.listTypeSelect.map((element)=>{
        if (this.update_type){
          if (this.update_type.label == element.label && element.label != '...')
            update_type = element.value
        }
      })
      this.listSelectStateFlag.map((element)=>{
        if (this.update_state){
          if (this.update_state.label == element.label && element.label != '...')
            update_state = element.value
        }
      })
      this.listFolderUpdate.map((element)=>{
        if (this.update_folder){
          if (this.update_folder.label == element.label && element.label != '...')
            update_folder = element.value
        }
      })
      return data_update = {
        update_mst_user : update_mst_user,
        update_type     : update_type,
        update_state    : update_state,
        update_folder   : update_folder,
      }
    },
    getRowStyle(params) {
      const { data } = params; //is_read d4ecea
      return (data.is_read == 1) ? { background: '#eee' } : null;
    },
    rowClickChanged(event){
      //Check row is selected
      let selected = event.node.selected;
      if (selected) {
        this.listMailReceiveSelect.push(event.data);
      } else {
        this.listMailReceiveSelect = this.listMailReceiveSelect.filter(mail => mail.id != event.data.id)
      }
      // get status read = 1 and unread = 0
      let unreadCount  = this.listMailReceiveSelect.some(item => item.is_read === 0);
      this.statusIsRead = unreadCount ? 1 : 0;
    },
    onSelectionChangedState() {
      //Get selected rows
      let selectedStates = this.gridApiState.getSelectedRows();
      let listStateSelected = [];
      selectedStates.forEach(function (selectedState, index) {
        listStateSelected.push(selectedState.content);
      });
      //Get index when row drag
      let list = this.rowDragChanged();
      let orderedSelectedList = list.filter(
        (ele) => listStateSelected.indexOf(ele) >= 0
      );
      this.listStateDisplaySelect = orderedSelectedList;
    },
    async onSelectionChangedRule(){
      let selectedRule = this.gridApiRule.getSelectedRows()
      if (selectedRule.length == 0){ //No row selected
        this.ruleSelected = null
      }
      else{
        this.ruleSelected = selectedRule[0].id
        await this.loadRuleSelection(this.ruleSelected)
      }
    },
    async onSelectionChangedSignature(){
      let selectedSignature = this.gridApiSignature.getSelectedRows()
      let listSignatureSelectId = [];
      selectedSignature.forEach(function (selectedRow, index) {
        listSignatureSelectId.push(selectedRow.id);
      });
      this.listSignatureSelect = listSignatureSelectId;
    },
    async loadRuleSelection(id){
        //Load detail Rule
        let rule = this.listRuleReceiveMail.filter(rule => rule.id == id);
        if (!rule || rule.length == 0) return;
        else rule = rule[0];
        this.listTypeSelect.map((element)=>{
          if (rule.type == element.value) this.type_rule = {label : element.label, value : element.value}
        })
        this.listFolderReceiveMail.map((element)=>{
          if (rule.folder == element.id) this.folder_rule = {label : element.name, value : element.id}
        })
        this.listSelectStateFlag.map((element)=>{
          if (rule.state == element.value) this.state_rule = {label : element.label, value : element.value}
        })
        this.listMstUserSelectRemoveNotSet.map((element)=>{
          if (rule.mst_user == element.value) this.manage_rule = {label : element.label, value : element.value}
        })
        this.listSubjectRule.map((element)=>{
          if (rule.subject == element.value) this.subject_rule = {label : element.label, value : element.value}
        })
          this.search_rule   = rule.search_string,
          this.name_rule     = rule.name
          this.stateOption_name = rule.state_flg == 1 ? '有効' : '無効'
          this.enableApplyRuleButton = rule.state_flg == 1 ? true : false
    },
    async renderDataRule(){
      let subject_rule = null;
      let folder_rule = null;
      let type_rule = null;
      let state_rule = null;
      let manage_rule =null;
      let state_data = {};

      let response = await this.getListKinds();
      response.map((element)=>{
        if (this.type_rule){
          if (this.type_rule.label == element.kinds_name)
            type_rule = element.type_id
        }
      })
      this.listFolderReceiveMail.map((element)=>{
        if (this.folder_rule){
          if (this.folder_rule.label == element.name)
            folder_rule = element.id
        }
      })
      this.listSelectStateFlag.map((element)=>{
        if (this.state_rule){
          if (this.state_rule.label == element.label)
            state_rule = element.value
        }
      })
      this.listMstUserSelectRemoveNotSet.map((element)=>{
        if (this.manage_rule){
          if (this.manage_rule.label == element.label){
            manage_rule = element.value
          }
        }
      })
      this.listSubjectRule.map((element)=>{
        if (this.subject_rule){
          if (this.subject_rule.label == element.label){
            subject_rule = element.value
          }
        }
      })
       return state_data = {
        subject_rule : subject_rule,
        folder_rule : folder_rule,
        type_rule: type_rule,
        state_rule: state_rule,
        manage_rule: manage_rule
        }
      
    },
    rowDragChanged() {
      let rowData = [];
      let list = [];
      this.gridApiState.forEachNode((node) => rowData.push(node.data));
      rowData.forEach(function (row, index) {
        list.push(row.content);
      });
      this.sort_display = list;
      return list;
    },
    onSortChanged(event) {
      const isDateRangeExceeded = this.handleInvalidDateRange(() => {
          event.api.setSortModel(null);
      });
      if (isDateRangeExceeded) return;

      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function (column) {
        // root.orderDir = column.getSort();
        if (column.getSort()) {
          root.orderDir = column.getSort();
          if (column.getColId() == 'parsed_body'){
            root.orderBy = 'body'
          }
          else{
            root.orderBy = column.getColId();
          }
          root.onSearch(false);
        }
      });
    },
    updateSortParams(orderBy, orderDir) {
      this.orderBy = orderBy;
      this.orderDir = orderDir;
    },
    getListMstUserSelect(resListMstUserSelect) {
      if (resListMstUserSelect) {
        this.listMstUserSelect = [
          {
            label: "...",
            value: "",
          },
          {
            label: "未設定",
            value: 0,
          }
        ];
        resListMstUserSelect.map((element) => {
          let result = {};
          result.value = element.id;
          result.label = element.full_name;
          this.listMstUserSelect.push(result);
        });
        this.listMstUserSelectRemoveNotSet = this.listMstUserSelect.filter(function(mst_user_id, index, arr){
            return (mst_user_id.value !== 0);
        });
      } else {
        this.listMstUserSelect = [
          {
            label: "...",
            value: "",
          },
        ];
        this.listMstUserSelectRemoveNotSet = [
          {
            label: "...",
            value: "",
          },
        ];
      }
    },
    onSendReport() {
      // this.$router.push(`/sent/${this.currentMailBoxSelected}/create-mail`);
       let routePath = `/sent/${this.currentMailBoxSelected}/create-mail?back=true`;
       window.open(routePath, '_blank');

    },
    handleInvalidDateRange(rollbackFn) {
        const maxDays = 90;
        const countDays = getDateRange(this.receive_date_search_from, this.receive_date_search_to);

        if (countDays <= maxDays) return false;

        // Avoid loops when rollback triggers watcher/event.
        if (rollbackFn) {
            if (this.isRollingBack) {
                this.isRollingBack = false;
                return true;
            }
            this.isRollingBack = true;
            rollbackFn();
        }

        this.$vs.notify({
            position: 'bottom-right',
            text: notifyInquiryPeriodLimit,
            color: 'danger'
        });

        return true;
    },
    async onSearch(
      resetPaging,
      isRefetch = null,
      mailBox = null,
      folder = null
    ) {
      if (this.handleInvalidDateRange()) return;
      let mst_user_id = "";
      if (this.checkIsMultiple.mst_user) {
        if (this.mst_user_search && this.mst_user_search.length && this.mst_user_search.length > 0) {
          mst_user_id = this.mst_user_search
        }
      } else {
        if (this.mst_user_search) {
          mst_user_id = this.mst_user_search.value;
        }
      }
      let state_flg = "";
      if (this.checkIsMultiple.state_flg) {
        if (this.state_flg_search && this.state_flg_search.length && this.state_flg_search.length > 0) {
          state_flg = this.state_flg_search
        }
      } else {
        if (this.state_flg_search) {
          state_flg = this.state_flg_search.value;
        }
      }
      let type = "";
      if (this.checkIsMultiple.type) {
        if (this.type_search && this.type_search.length && this.type_search.length > 0) {
          type = this.type_search
        }
      } else {
        if (this.type_search) {
          type = this.type_search.value;
        }
      }
      let inquiry_type = "";
      if (this.inquiry_type_search) {
        inquiry_type = this.inquiry_type_search.value;
      }
      let action = "";
      if (resetPaging === true && mailBox === null) {
        action = "search";
      }
      if (mailBox === null) {
        mailBox = this.currentMailBoxSelected;
      }
      //seach by customer matched,
      let customerLinked = "";
      if(this.customer_domain_search){
        customerLinked = this.customer_domain_search.value;
      }
      let prioritySearch = null;
      if(this.priority_search) {
        prioritySearch = this.priority_search.value;
      }
      //
      // process order by
      if (this.orderBy) {
        if (this.orderBy === "state_flg_text") {
          this.orderBy = "state_flg";
        }
        if (this.orderBy === "inquiry_type_text") {
          this.orderBy = "inquiry_type";
        }
        if (this.orderBy === "type_text") {
          this.orderBy = "type";
        }
      }
      let page = this.pagination.currentPage;
      if (resetPaging === true) page = 1;
      if (this.isCreated) {
        page =
          this.searchFilter && this.searchFilter.mailBox === mailBox
            ? this.searchFilter.queries.page
            : 1;
        if (
          this.listMailReceived.length === 1 &&
          this.startRow === 1 &&
          this.endRow === 1 &&
          this.pagination.totalItem === 0
        ) {
          this.searchFilter
            ? (page = this.searchFilter.queries.page - 1)
            : (page = 1);
        }
      }
      let folderSearch = folder;
      if (this.$route.fullPath.includes("folder") == true) {
        folderSearch =
          this.$route.fullPath.split("/")[
            this.$route.fullPath.split("/").length - 1
          ];
      }
      let params = {
        folder: folderSearch,
        mailBox: mailBox,
        queries: {
          inquiry_type: inquiry_type,
          receive_datetime_from: this.receive_date_search_from ? this.receive_date_search_from : this.setDateDefault(),
          receive_datetime_to: this.receive_date_search_to ? this.receive_date_search_to : this.setDateDefault('to'),
          email_sender:
            this.email_sender_search === "..." ? "" : this.email_sender_search,
          response_limit: this.response_date_search,
          inquiry_id: this.inquiry_id_search,
          mst_user_id: mst_user_id,
          receive_mail_email_sender: this.receive_mail__email_sender_search,
          state_flg: state_flg,
          subject: this.subject_search,
          body: this.body_search,
          type: type,
          type_mail: this.isSpamView ? 1 : 0,
          action: action,
          page: page,
          limit: this.pagination.limit,
          orderBy: this.orderBy,
          orderDir: this.orderDir,
          cc: this.cc_search__email_sender_search,
          to: this.to_search__email_sender_search,
          refetch_from: this.refetch_from_date,
          refetch_to: this.refetch_to_date,
          getfolder: folderSearch,
          priority: prioritySearch,

          //todo search by customer
          customerLinked: customerLinked,
          //search include subfolder
          include_subfolder: this.searchSubFolder,
        },
      };
      let data = null;
      if (!isRefetch) {
        // TODO 21-13
        data = await this.getMailReceive(params)
      } else {
        if (this.refetch_from_date && this.refetch_from_date != "" && this.refetch_to_date && this.refetch_to_date != ""){
          await this.refetchMailReceive(params);
        }
         this.activeRefetch = false;
         data = await this.getMailReceive(params)
      }
      this.handleMailSelected();
      this.setSearchFilter(params);
      this.pagination.totalItem = data.total;
      this.pagination.totalPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.limit = data.per_page;
      this.pagination.from = data.from;
      this.pagination.to = data.to;

      //Set popup down
      this.activeRefetch = false;
      // If there is no data left and it is not the first page, go back to the previous page.
      if (data.data.length == 0 && this.pagination.currentPage > 1) {
          this.pagination.currentPage--;
          this.onSearch(false, mailBox);
      }
      //Load preview mode
      if (this.mode) this.loadPreviewMode();

    },
    getListMailSendUserSelect(resListMailSendUserSelect) {
      if (resListMailSendUserSelect) {
        this.listSentUserNameSelect = ["..."];
        resListMailSendUserSelect.map((element) => {
          this.listSentUserNameSelect.push(element.sent_user_name);
        });
      } else {
        this.listSentUserNameSelect = ["..."];
      }
    },
    getListKindsSelect(resListKindsSelect) {
      if (resListKindsSelect) {
        this.listTypeSelect = [
          {
            label: "...",
            value: "",
          },
        ];
        resListKindsSelect.map((element) => {
          let result = {};
          result.value = element.type_id;
          result.label = element.kinds_name;
          this.listTypeSelect.push(result);
        });
      } else {
        this.listTypeSelect = [
          {
            label: "...",
            value: "",
          },
        ];
      }
    },
    clearSearchOption() {
      this.inquiry_type_search = {
        value: "",
        label: "...",
      };
      this.receive_date_search_from = this.setDateDefault();
      this.receive_date_search_to = this.setDateDefault('to');
      this.response_date_search = "";
      this.email_sender_search = "";
      this.inquiry_id_search = "";
      this.mst_user_search = "";
      this.receive_mail__email_sender_search = "";
      this.state_flg_search = {
        value: "",
        label: "...",
      };
      this.type_search = {
        value: "",
        label: "...",
      };
      this.priority_search = {
        label: "...",
        value: null
      };
      this.subject_search = "";
      this.body_search = "";
      this.to_search__email_sender_search = "";
      this.cc_search__email_sender_search = "";
      //CheckMultiple v-Select
      this.checkIsMultiple =  {
        state_flg: false,
        mst_user : false,
        type     : false,
      };

      this.customer_domain_search = null;
      this.listMailReceiveSelect = [];
    },
    async resetColFilters(isRefetch = null) {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
      this.clearSearchOption();
      this.clearSearchFilter();
      await this.onSearch(true, isRefetch);
      await this.getListMailBox();
      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      if (this.mode) {
        this.loadPreview();
      }
    },
    onGridReadyState(params) {
      this.gridApiState = params.api;
      this.columnApiState = params.columnApi;
    },
    onGridReadyRule(params) {
      this.gridApiRule = params.api;
      this.columnApiRule = params.columnApi;
    },
    onGridReadySignature(params) {
      this.gridApiSignature = params.api;
      this.columnApiSignature = params.columnApi;
    },
    lockSigned() {
      const listKey = [
        17, 93, 65, 67, 86, 88, //ctrl, cmd, a, c, v, x
        8, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105 //Numoad
      ];
      window.onkeydown = function (e) {
        let key = e.charCode || e.which || e.keyCode;
        let check = listKey.find((keyCode) => key === keyCode);
        if (!check) {
          return false;
        } else return true;
      };
    },
    unlockSigned() {
      window.onkeydown = null;
    },
    mailBoxSelectable() {
      let mailBox = this.listMailBox.find(
        (item) => item.receive_user_name === this.$route.params.email
      );
      if (!mailBox.numberMailNotSupport)
        document.getElementsByClassName(
          "ag-header-select-all ag-labeled ag-label-align-right ag-checkbox"
        )[0].style.opacity = "0.5";
      else
        document.getElementsByClassName(
          "ag-header-select-all ag-labeled ag-label-align-right ag-checkbox"
        )[0].style.opacity = "1";
    },
    getCustomerLinked(resCustomerLinked){
      this.list_customer_select_res = [
        {
          label: "...",
          value: null,
          receive_mail: null,
          matched_at: null
        }
      ];

      resCustomerLinked.forEach(customer => {
        this.list_customer_select_res.push(Object.assign({
          label: !customer.company_name ? customer.full_name : customer.company_name,
          value: customer.id,
          receive_mail: customer.receive_mail,
          matched_at: customer.matched_at
        }));
      });
      this.listCustomerSelect = this.list_customer_select_res.filter(item => item.value == null || item.receive_mail === this.$route.params.email);
    },
    async refetch() {
      if (!this.refetch_from_date || this.refetch_from_date == "") {
        this.$vs.notify({
          position: "bottom-right",
          text: "からは必須です",
          color: "danger",
        });
        return;
      }
      if (!this.refetch_to_date || this.refetch_to_date == "") {
        this.$vs.notify({
          position: "bottom-right",
          text: "までは必須です",
          color: "danger",
        });
        return;
      }
      await this.resetColFilters(true);
    },
    onRowDrag(params) {
      let rowNode = params.rowNode;
      let jsonObject = {
        id: rowNode.data.id,
        receive_mail: rowNode.data.receive_mail,
      };
      params.dragEvent.dataTransfer.setData(
        "application/json",
        JSON.stringify(jsonObject)
      );
      this.setReload(this.onSearch);
    },
    async saveStateDisplay() {
      let params = {
        header_display: this.listStateDisplaySelect,
        sort_display: this.sort_display,
        type: this.type_mail,
      };
      if (await this.saveUserSetting(params)) {
        this.activeStateDisplay = false;
        await this.loadDisplay();
        this.gridApi.sizeColumnsToFit();
      }
    },
    async activePopupState() {
      this.activeStateDisplay = true;
      let dataDisplay = await this.refreshUserSetting(this.listUserSetting);
      this.loadCheckBox(dataDisplay);
      this.gridApi.sizeColumnsToFit();
    },

    async loadDisplay() {
      //get setting display
      let dataDisplay = await this.getUserSetting(this.type_mail);
      this.loadCheckBox(dataDisplay);
    },
    loadCheckBox(data) {
      this.data_display = data;
      this.gridColumnApi.resetColumnState();
      if (!this.data_display) {
        this.gridApiState.forEachNode(function (node) {
          node.setSelected(true);
        });
      } else {
        let listDisplay = this.data_display.header_display.split(";");
        this.gridApiState.forEachNode(function (node) {
          node.setSelected(listDisplay.indexOf(node.data.content) >= 0);
        });
      }
    },
    async onPreviewModeSelectionChanged() {
      let mailBox = this.$route.params.email;
      let selectedRows = this.gridApi.getSelectedRows();
      let params = {
        mailBox: mailBox,
        id: selectedRows[0].id,
        type: 0
      }
      try {
        let selectedReceiveMail = await this.getSelectedMailPreviewMode(params);
        selectedReceiveMail.attachmentFileName = [];
        if (selectedReceiveMail.attachment_filepath){
          let listattachmentFiles = selectedReceiveMail.attachment_filepath.split(',')
          listattachmentFiles.forEach((element)=>{
          selectedReceiveMail.attachmentFileName.push({
              path: element,
              file_name: element.split('/').reverse()[0]
            })
          });
        }
        this.selectedReceiveMail = selectedReceiveMail;

        const scrollElement = this.receive_mail.body_type == 0 ? 'receiveMailBodyBlock' : 'receiveMailBodyTextarea';
        const topScrollElement = document.getElementById(scrollElement);
        if (topScrollElement) topScrollElement.scrollTop = 0;

      } catch (error) {
        const message = (error && error.response.data && error.response.data.message) || notifyEmptyReceive;
        this.$vs.notify({
            position: 'bottom-right',
            text: message,
            color: 'danger'
        });
        if (error.response.status == 410) {
            await new Promise(resolve => setTimeout(resolve, 500));
            await this.onSearch(false, mailBox);
        }
      }
     
    },
    async downloadAttachment(file) {
      let data = {
        "id" : this.receive_mail.id,
        "fileName" : file,
      }
      let result = await this.downloadFile(data);
      if (result) {
        handleDownloadAttachment(result);
      }
    },
    async editReceiveMailDetail(id) {
      try {
          let params = {
              mailBox: this.$route.params.email,
              id: id,
              type: 0
          }
          await this.getSelectedMailPreviewMode(params);
      } catch (error) {
          this.$vs.notify({
              position: 'bottom-right',
              text: notifyEmptyReceive,
              color: 'danger'
          });

          await new Promise(resolve => setTimeout(resolve, 500));

          await Promise.all([
              this.onSearch(false),
              this.getListMailBox()
          ]);

          return false;
      }
      if (this.$route.fullPath.includes('folder') || this.$route.fullPath == `/box/${this.currentMailBoxSelected}`){
        this.setSelectedMailFolder(this.$route.fullPath);
      }
      let mail = this.listMailReceived.find((item) => item.id == id);
      if (mail && mail.inquiry_id) {
        let routePath = `/box/${this.currentMailBoxSelected}/${mail.inquiry_id}?back=true`;
        if (this.$route.query.mode == 'shachihatadesk'){
          let targetOrigin = '*';
          let location = window.location.origin;
          routePath += '&mode=shachihatadesk';
          if (this.$route.query.urlorigin) {
            routePath += `&urlorigin=${this.$route.query.urlorigin}`;
            targetOrigin = this.$route.query.urlorigin;
          }
          const tokenLogin = await this.handleGetByUid();
          let dataPost = {
            type:'pac21_link',
            from: location +'/',
            token: tokenLogin ? btoa(tokenLogin) : '',
            result: location + routePath
          }
          window.parent.postMessage(dataPost, targetOrigin)
        }else{
          window.open(routePath, '_blank');
        }
      }
    },
    async loadPreviewMode() {
      this.loadPreview();
    },
    loadPreview() {
      if (this.selectedReceiveMail) {
        let isNewPage = true;
        this.gridApi.forEachNode((node) => {
          isNewPage =
            this.selectedReceiveMail.id == node.data.id ? false : isNewPage;
          node.setSelected(
            this.selectedReceiveMail.id == node.data.id,
            true,
            true
          ); //Prevent call back to onPreviewModeSelectionChanged
        });
        if(!isNewPage) {
           // refresh data while mail is selected
           this.onPreviewModeSelectionChanged();
        }
        //Set node[0] when direct to new page
        if (isNewPage && this.gridApi.getRowNode(0)) this.gridApi.getRowNode(0).setSelected(true);
        else if (this.listMailReceived && this.listMailReceived.length == 0) this.selectedReceiveMail = {};
      } else {
        this.gridApi.getRowNode(0).setSelected(true);
      }
    },
    //Rule Sorting action
     async activePopUpSortRule(){
       if (this.handleInvalidDateRange()) return;
       //Clear rule detail
        this.subject_rule = null
        this.search_rule  = null
        this.folder_rule  = null
        this.state_rule   = null
        this.manage_rule  = null
        this.type_rule    = null
        this.name_rule    = null
        this.gridApiRule.forEachNode(function (node) {
          node.setSelected(false)
        });
        //Show popup
        this.activeSortRule = true
    },
      //Add new Rule
    async addRule(){
      if (!this.validateForm){
        this.submittedRule = true
      }
      else{
        let dataRule =  await this.renderDataRule()
        let data = {
          mailBox: this.$route.params.email,
          subject: dataRule.subject_rule,
          search_string : this.search_rule,
          folder : dataRule.folder_rule,
          type   : dataRule.type_rule, 
          state  : dataRule.state_rule, 
          state_flg: this.stateOption_name == '有効' ? 1 : 0,
          mst_user: dataRule.manage_rule,
          name : this.name_rule
        }
        if (!data.mst_user && data.state != 0 && data.state){
          this.$vs.notify({
            position: 'bottom-right',
            text: '担当者が入力していないため、お問い合わせ詳細の更新に失敗しました。',
            color: 'danger'
          })
        } else {
          await this.addRuleReceiveMail(data)
          await this.getRuleReceiveMail(data.mailBox)
        }
      }
    },
      //Delete Rule Selected
    async deleteRule(){
      let data = {
        mailBox : this.$route.params.email,
        id      : this.ruleSelected
      }
      if (await this.deleteRuleReceiveMail(data)){
        this.activeDeleteRule = false
        await this.getRuleReceiveMail(data.mailBox)
        this.ruleSelected = null
        //Clear rule detail
        this.subject_rule = null
        this.search_rule  = null
        this.folder_rule  = null
        this.state_rule   = null
        this.manage_rule  = null
        this.type_rule    = null
        this.name_rule    = null
      }
    },
      //Update Rule Selected
    async updateRule(){
      if (!this.validateForm){
        this.submittedRule = true
      }
      else{
        let dataRule = await this.renderDataRule();
        let data = {
          id     : this.ruleSelected,
          mailBox: this.$route.params.email,
          subject: dataRule.subject_rule,
          search_string : this.search_rule,
          folder : dataRule.folder_rule,
          type   : dataRule.type_rule, 
          state  : dataRule.state_rule, 
          state_flg: this.stateOption_name == '有効' ? 1 : 0,
          mst_user: dataRule.manage_rule,
          name : this.name_rule
        }
        if (!data.mst_user && data.state != 0 && data.state){
          this.$vs.notify({
            position: 'bottom-right',
            text: '担当者が入力していないため、お問い合わせ詳細の更新に失敗しました。',
            color: 'danger'
          })
        } else {
          await this.updateRuleReceiveMail(data)
          await this.getRuleReceiveMail(data.mailBox)
          this.submittedRule = false
          this.enableApplyRuleButton = data.state_flg
          let ruleSelected = this.ruleSelected
          //Set current selected rule after updated
          this.gridApiRule.forEachNode(function (node) {
            node.setSelected(ruleSelected == node.data.id, true, true)
          });
        }
      }
    },
      //Apply Rule All Mail from past to present
    async applyRule(){
      let params = {
        mailBox: this.$route.params.email,
        id: this.ruleSelected
      }
      await this.applyRuleReceiveMail(params)
      this.activeApplyRule = false
      let mailBox = this.$route.params.email;
      let folder = null;
      if (this.$route.fullPath.includes("folder") == true) {
        folder =
          this.$route.fullPath.split("/")[
            this.$route.fullPath.split("/").length - 1
          ];
      }if (this.$route.fullPath.includes('folder') || this.$route.fullPath == `/box/${this.currentMailBoxSelected}`)     this.setSelectedMailFolder(this.$route.fullPath);
      await this.onSearch(false,null,mailBox,folder)
    },

    //Create new Signature
    async createSignature(){
      if (!this.validateForm){
        this.submittedSignature = true; // true: show error validate
      }
      else{
        let params = {
        signature_name :  this.signature_name,
        signature : '<pre>' + this.user_signature + '<pre>',
        signature_type :  this.modeHTML == true ? 0 : 1
        }
        if (await this.createUserSignature(params)){
          await this.getUserSignature();
          this.listSignatureSelect = []
          this.activeUpdateSignature = false
        }
      }
    },
    //Delete signature(s)
    async deleteSignature() {
      if (await this.deleteUserSignature(this.listSignatureSelect)){
        this.activeDeleteSignature = false
        await this.getUserSignature();
        this.listSignatureSelect = []
        this.activeUpdateSignature = false
        this.signature_name = ''
        this.user_signature = ''
      }
    },
    async editSignature(){
      if (!this.validateForm){
        this.submittedSignature = true;
      }
      else{
        let params = {
        id             : this.listSignatureSelect,
        signature_name :  this.signature_name,
        signature :  '<pre>' + this.user_signature + '<pre>',
        signature_type :  this.modeHTML == true ? 0 : 1
        }
        if (await this.updateUserSignature(params)){
          await this.getUserSignature();
          this.listSignatureSelect = []
          this.activeUpdateSignature = false
        }
      }
    },
    async deleteSelect () {
        let ids = this.listMailReceiveSelect.map(mail => mail.id);
        this.listMailReceiveSelect = [];

        let params = {
            mailBox: this.$route.params.email,
            id: ids
        }

        if (ids.length === 0) return;

        await this.deleteMailReceive(params)
        this.activeDeletePopUp = false;
        this.listMailReceiveSelect = [];

        // Ensure current page is valid after deleting items
        const newTotalItems = this.pagination.totalItem - ids.length;
        const maxPage = Math.ceil(newTotalItems / this.pagination.limit);

        // If the current page exceeds the new maximum page, revert
        if (this.pagination.currentPage > maxPage) {
            this.pagination.currentPage = Math.max(1, maxPage);
        }

        await Promise.all([
            this.onSearch(false),
            this.getListMailBox()
        ]);
    },
    async refreshPage() {
      if (localStorage.refreshPage) {
        if (localStorage.refreshPage == 'draft'){
          localStorage.removeItem("refreshPage");
        } else{
          localStorage.removeItem("refreshPage");
          let mailBox = this.$route.params.email;
          let folder = null;
          if (this.$route.fullPath.includes("folder") == true) {
            folder = this.$route.fullPath.split("/")[this.$route.fullPath.split("/").length - 1];
          }
          if (mailBox) {
            await this.onSearch(false, null, mailBox, folder);
          }
        }
      }
    },
    selectionChangedvSelect(){
      if (this.state_flg_search && this.state_flg_search.length >= 0) {
        if (this.state_flg_search.includes('') || this.state_flg_search.length == 0) {
          this.state_flg_search = [];
        }
      }
      if (this.mst_user_search && this.mst_user_search.length >= 0) {
        if (this.mst_user_search.includes('') || this.mst_user_search.length == 0) {
          this.mst_user_search = [];
        }
      }
      if (this.type_search && this.type_search.length >= 0) {
        if (this.type_search.includes('') || this.type_search.length == 0) {
          this.type_search = [];
        }
      }
      setTimeout(() => this.checkSelected(), 0);
    },
    openvSelect(){
      if (!this.checkIsMultiple.state_flg) {
        this.checkIsMultiple.state_flg = true;
      }
      if (!this.checkIsMultiple.mst_user) {
        this.checkIsMultiple.mst_user = true;
      }
      if (!this.checkIsMultiple.type) {
        this.checkIsMultiple.type = true;
      }
      setTimeout(() => this.checkSelected(), 0);
    },
    checkSelected() {
      let mst_user    = document.querySelectorAll('#mst_user_search>ul>li');
      let state_flg   = document.querySelectorAll('#state_flg_search>ul>li');
      let type_search = document.querySelectorAll('#type_search>ul>li');
      if (mst_user && mst_user.length > 0) {
        mst_user.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }
      if (state_flg && state_flg.length > 0) {
        state_flg.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }
       if (type_search && type_search.length > 0) {
        type_search.forEach((element)=>{
        let className = element.getAttribute('class');
        //Check exist element <b>
        let check = element.querySelector('li>b');
        if (check) {
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        } else {
          //Create element <b> if not exist
          let check = document.createElement('b');
          check.textContent = "✓"
          element.prepend(check)
          if (className.includes('selected')) check.style.visibility = "visible"
          else check.style.visibility = "hidden"
        }
        })
      }

    },
    setDateDefault(type = 'from') {
      let defaultDate = new Date();
      //One month ago
      if (type == 'from') {
        defaultDate.setDate(defaultDate.getDate() - 13);
      }
      //Format date according to Asia/Tokyo timezone and standardize to YYYY-MM-DD format
      return defaultDate.toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit' }).slice(0,10).replace(/\//g, '-');
    },
    pollNotification() {
      this.pollingNotification = setInterval(() => {
        localStorage.setItem("noLoading", "true");
        let mailBox = this.$route.params.email;
        if (this.$route.path.startsWith('/box/') && mailBox){
          let notifications = this.getNotifications(mailBox)
          notifications.then(async notification=>{
            if (notification && notification.length > 0) {
              let folder = null;
              if (this.$route.fullPath.includes("folder") == true) {
                folder = this.$route.fullPath.split("/")[this.$route.fullPath.split("/").length - 1];
              }
              localStorage.setItem("noLoading", "true");
              await this.onSearch(false, null, mailBox, folder);
            }
            notification.forEach(notify=>{
              this.listNotifications.push(notify)
            })
          })
        }
      }, 60 * 1000)
    },
    showNotify(){
      this.showNotification = setInterval(()=>{
        for (let i = 0 ; i < 5 ; i++){
          if (this.listNotifications && this.listNotifications.length > 0){
            this.$vs.notify({
              time: 3000,
              position: 'top-center',
              title: this.listNotifications[0].email_sender_full,
              text: this.listNotifications[0].subject,
              color: 'primary'
            });
            this.listNotifications.shift();
          }
        }
      }, 3 * 1000)
    },
    handleSearchSubFolder(){
      let userInfo = JSON.parse(getLS("userInfo"));
      let listIncludeSubFolder = JSON.parse(this.listIncludeSubFolder);
      if (!listIncludeSubFolder || (listIncludeSubFolder && listIncludeSubFolder.length == 0)) {
        this.searchSubFolder = false;
      } else {
        let includeSubFolderisCheck = listIncludeSubFolder.filter(check => check.id == userInfo.id && check.mail_server.includes(this.$route.params.email)).length == 0 ? false : true;
        if (includeSubFolderisCheck) this.searchSubFolder = true;
        else this.searchSubFolder = false;
      }
    },
    handleMailSelected(){
      this.gridApi.forEachNode(node => {
        //Check row id exist in list Selected
        let checkExist = this.listMailReceiveSelect.filter(mail => mail.id == node.data.id).length == 0 ? false : true;
          if (checkExist) {
            node.setSelected(true);
          }
      });
    },
    async onExportCSV(){
      if (this.handleInvalidDateRange()) return;
      //Get body export CSV
      let listIdSelected = this.listMailReceiveSelect.map(mail => mail.id);
      let data = await this.getDataExportCSV({ids :listIdSelected});
      if (!data) {
          await new Promise(resolve => setTimeout(resolve, 500));
          await Promise.all([
              this.onSearch(false),
              this.getListMailBox()
          ]);
          return;
      }
      //Create label CSV
      const labelMailExport = Object.assign({
        inquiry_type: { title: '方法' },
        receive_date: { title: 'お問い合わせ日' },
        response_limit: { title: '回答期限' },
        mst_user: { title: '担当者' },
        state_flg: { title: '状態' },
        type: { title: '種別' },
        inquiry_id: { title: 'お問い合わせID' },
        email_sender: {title: 'お問い合せ者'},
        subject: { title: 'タイトル' },
        body: { title: 'メール本文' },
      });
      //Create data CSV
      const dataExport = this.listMailReceiveSelect.filter(mail => data.hasOwnProperty(mail.id)).map(mail => {
        const mailInfo = {
          inquiry_type: mail.inquiry_type_text || '',
          receive_date: mail.receive_datetime ? mail.receive_datetime.slice(0,10) : '',
          response_limit: mail.response_limit ? mail.response_limit.slice(0,10) : '',
          mst_user: mail.full_name || '未設定',
          state_flg: mail.state_flg_text || '',
          type: mail.kinds_name || '',
          inquiry_id: mail.inquiry_id || '',
          email_sender: mail.email_sender || '',
          subject: mail.subject || '',
          body: data[mail.id] || '',
        }
        return mailInfo
      });
      this.$refs.exportCSV.labels = labelMailExport;
      this.$refs.exportCSV.jsonData = dataExport;
      this.$refs.exportCSV.handleClick();
      this.listMailReceiveSelect = [];
      this.gridApi.deselectAll();
    },
    openvSelectPriority(){
      setTimeout(()=>{
        const lowPriority = document.getElementById("gif-low-priority").getAttribute("src");
        const mediumPriority = document.getElementById("gif-medium-priority").getAttribute("src");
        const highPriority = document.getElementById("gif-high-priority").getAttribute("src");
        const colectionGif = [' ', ' ' , lowPriority, mediumPriority, highPriority]
        const priority = document.querySelectorAll('#priority_search>ul>li');
        if (priority && priority.length > 0) {
          priority.forEach((element, index)=>{
            let gif = document.createElement('img');
            gif.src = colectionGif[index]
            gif.style = "display:inline"
            element.prepend(gif)
          })
        }
      },0)
    },
    selectionChangedPriority() {
      setTimeout(()=>{
        const lowPriority = document.getElementById("gif-low-priority").getAttribute("src");
        const mediumPriority = document.getElementById("gif-medium-priority").getAttribute("src");
        const highPriority = document.getElementById("gif-high-priority").getAttribute("src");
        const colectionGif = [lowPriority, mediumPriority, highPriority]
        const contentApplyGif = ['低', '中', '高']
        const priority = document.querySelectorAll('#priority_search>div>div>span');
        if (priority && priority.length > 0) {
          contentApplyGif.forEach((element, index) => {
            if (priority[0].textContent.includes(element)) {
              let gif = document.createElement('img');
              gif.src = colectionGif[index]
              gif.style = "display:inline"
              priority[0].prepend(gif)
            }
          })
        }
      })
    }
  },
   mounted() {
    this.gridApi = this.gridOptions.api;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    EventBus.$on("editRecord", (id) => {
      if (this.activePopupSignature){
        this.signature_name = ''
        this.user_signature = ''
        this.listUserSignature.map((element)=>{
          if (id == element.id){
            this.listSignatureSelect = [id]
            this.modeHTML = element.signature_type == 0 ? true : false
            this.signature_name = element.signature_name
            this.user_signature = element.signature
            this.activeUpdateSignature = true
          }
        })
      }

    });
    this.mailBoxSelectable();
    this.clearSearchFilterSend();
    this.pollNotification();
    this.showNotify();

    window.addEventListener("beforeunload", this.resetColFilters);
    window.addEventListener('storage', this.refreshPage);
    setupIconClickEvent();
  },
  async created() {
    /* start loading with many requests */
    this.$store.dispatch("updateLoads", true);
    let mailBox = this.$route.params.email;
    let folder = null;
    if (this.$route.fullPath.includes("folder") == true) {
      folder =
        this.$route.fullPath.split("/")[
          this.$route.fullPath.split("/").length - 1
        ];
    }
    if (this.$route.name === "spam") {
      this.isSpamView = true;
    } else {
      this.isSpamView = false;
      this.handleSearchSubFolder();
    }
    await this.getListMailBox();
    await this.getUserSignature();
    if (!mailBox) {
      if (this.listMailBox && this.listMailBox.length > 0) {
        mailBox = this.listMailBox[0].receive_user_name;
      }
    } else {
      if (
        this.listMailBox &&
        this.listMailBox.length > 0 &&
        this.listMailBox.find((mb) => mb.receive_user_name == mailBox)
      ) {
        //...
      } else mailBox = null;
    }
    if (mailBox) {
      this.receive_date_search_from = this.setDateDefault();
      this.receive_date_search_to = this.setDateDefault('to');
      let mailBoxInfo = await this.listMailBox.find(
          (element) => element.receive_user_name == this.$route.params.email
      );
      let params = null;
      if (mailBoxInfo) {
        params = {
          mst_mail_server_id: mailBoxInfo.id,
        };
      }else{
        params = {};
      }

      let response = await this.getMasterData(params);
      if (response){
        if (mailBoxInfo){
          this.getListMstUserSelect(response.listUserSelect);
        }
        this.getListMailSendUserSelect(response.listMailServerSentUser);
        this.getListKindsSelect(response.listKindsSelect);
        this.getCustomerLinked(response.customerLinked);
      }

      if (!this.listUserSetting || this.listUserSetting.length == 0) {
        await this.loadDisplay();
      }else{
        if (this.listUserSetting.type_mail == 1) await this.loadDisplay();
      }
      await this.getUserSetting(this.type_mail);
      await this.getFolderReceiveMail(mailBox);
      await this.getRuleReceiveMail(mailBox);
      this.gridApi.sizeColumnsToFit();
      if (!this.listUserSetting || this.listUserSetting.length == 0) {
        this.sort_display = this.listStateDisplaySelect;
        await this.saveStateDisplay();
      }
      if (
        this.searchFilter &&
        this.searchFilter.queries &&
        this.searchFilter.mailBox &&
        this.searchFilter.mailBox === mailBox
      ) {
        this.subject_search = this.searchFilter.queries.subject
          ? this.searchFilter.queries.subject
          : "";
        this.body_search = this.searchFilter.queries.body
          ? this.searchFilter.queries.body
          : "";
        this.inquiry_type_search = this.listInquiryTypeSelect.find(
          (inquiry) => inquiry.value === this.searchFilter.queries.inquiry_type
        );
        this.type_search = this.listTypeSelect.find(
          (type) => type.value === this.searchFilter.queries.type
        );
        this.state_flg_search = this.listSelectStateFlag.find(
          (state) => state.value === this.searchFilter.queries.state_flg
        );
        this.mst_user_search = this.listMstUserSelect.find(
          (user) => user.value === this.searchFilter.queries.mst_user_id
        );
        this.receive_mail__email_sender_search =
          this.searchFilter.queries.receive_mail_email_sender;
        this.inquiry_id_search = this.searchFilter.queries.inquiry_id
          ? this.searchFilter.queries.inquiry_id
          : "";
        this.email_sender_search = this.searchFilter.queries.email_sender
          ? this.searchFilter.queries.email_sender
          : "...";
        this.pagination.limit = this.searchFilter.queries.limit
          ? this.searchFilter.queries.limit
          : 10;
        this.receive_date_search_from = this.searchFilter.queries
            .receive_datetime_from
            ? this.searchFilter.queries.receive_datetime_from
            : this.receive_date_search_from;
        this.receive_date_search_to = this.searchFilter.queries
          .receive_datetime_to
          ? this.searchFilter.queries.receive_datetime_to
          : this.receive_date_search_to;
        this.response_date_search = this.searchFilter.queries.response_limit
          ? this.searchFilter.queries.response_limit
          : "";
        this.orderBy = this.searchFilter.queries.orderBy
          ? this.searchFilter.queries.orderBy
          : "receive_datetime";
        this.orderDir = this.searchFilter.queries.orderDir
          ? this.searchFilter.queries.orderDir
          : "asc";
        this.to_search__email_sender_search = this.searchFilter.queries.to
          ? this.searchFilter.queries.to
          : "";
        this.cc_search__email_sender_search = this.searchFilter.queries.cc
          ? this.searchFilter.queries.cc
          : "";
      }
      this.readOnly = await this.setUserReadOnly(mailBox) > 0;
      await this.onSearch(false, null, mailBox, folder);
      this.isCreated = false;
      this.callRequest = mailBox;
    } else {
      if(this.$route.query.mode == 'shachihatadesk'){
        this.$store.dispatch("alertError", 'アクセス権限がないため、対象メールアドレスの一覧が表示されません。', { root: true });
        this.$router.push({ path: "/" });
      }else{
        this.$router.push({ path: "/dashboard" });
      }
    } 

    /* stop loads */
    this.$store.dispatch("updateLoads", false);

  },
  updated() {
    this.$nextTick(() => {
      if (!this.$store.state.loading && this.listMailReceived.length > 0) {
        this.startRow =
          this.pagination.currentPage * this.pagination.limit -
          this.pagination.limit +
          1;
        if (this.listMailReceived.length == this.pagination.limit)
          this.endRow = this.pagination.currentPage * this.pagination.limit;
        else
          this.endRow =
            this.pagination.limit * this.pagination.currentPage +
            this.listMailReceived.length -
            this.pagination.limit;
      } else if (this.listMailReceived.length == 0) {
        this.pagination.totalItem = 0;
        this.startRow = 0;
        this.endRow = 0;
      }
    });
    this.mailBoxSelectable();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.resetColFilters, {
      passive: true,
    });
    EventBus.$off('editRecord');
    window.removeEventListener("storage", this.refreshPage);
    clearInterval(this.pollingNotification);
    clearInterval(this.showNotification);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";
@import "@/assets/scss/vuexy/components/view/mailBox.scss";

// css for this page
.ag-theme-material {
  .ag-selection-checkbox:not(.ag-hidden) ~ .ag-cell-value:not(:empty) {
    display: none;
  }
  .ag-row-selected {
    background-color: #eee !important;
  }
  .ag-row-hover  {
    background-color: #e6f2fa !important;
  }
}
.con-vs-popup.fullscreenBox {
  .vs-popup {
    width: 75vw;
  }
  .vs-popup--content{
    padding-top: 0px;
  }
}
#user_signature_textarea{
  font-size: 13px !important;
  font-family: Helvetica, Arial, sans-serif !important;
  line-height: 1.42 !important;
}
.page-mail-box-full {
  .vs-button {
    &:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {
      height: auto !important;
    }
  }
}
</style>
